import { createReactQueryHook } from '@cash-web/shared-data-access-api/types'
import { EnvironmentType, getEnvironmentAtRunTime } from '@cash-web/shared-util-environment'
import { retryFetch } from '@cash-web/shared-util-fetch'

const env = getEnvironmentAtRunTime()

const SQUARE_CLIENT_ID_PRODUCTION = 'sq0idp-Ku4zD6g2iaYcD4OD1rpxuw'
const SQUARE_CLIENT_ID_STAGING = 'sq0ids-a8K92O-Cf_ShhPSAnbx35g'
const LOCATION_ID = 'FJS9X82NTJW2Z'
const SQUARE_WEB_PAYMENTS_SDK_MERCHANT_ID = '05498866192997955200'

const PCI_CONNECT_BASE_URL: Partial<Record<EnvironmentType, string>> = {
  production: 'https://pci-connect.squareup.com',
  staging: 'https://pci-connect.squareupstaging.com',
  development: '',
}

const GOOGLE_PAY_JWT_CONFIG = {
  MERCHANT_NAME: 'Cash App',
  CLIENT_ID: env === 'production' ? SQUARE_CLIENT_ID_PRODUCTION : SQUARE_CLIENT_ID_STAGING,
  LOCATION_ID,
  MERCHANT_ID: SQUARE_WEB_PAYMENTS_SDK_MERCHANT_ID,
  GOOGLE_PAY_URL: `${PCI_CONNECT_BASE_URL[env]}/digital-wallets/google-pay/token`,
} as const

interface MerchantSessionResponse {
  token: string
}

export interface GetGooglePayJwtTokenRequest {
  validationUrl?: string
}

export interface GetGooglePayJwtTokenResponse {
  token: string
}

export const getGooglePayJwtToken = async (
  request: GetGooglePayJwtTokenRequest = {}
): Promise<GetGooglePayJwtTokenResponse> => {
  const validationUrl = request.validationUrl ?? `${window.location.origin}${window.location.pathname}`

  const merchantSessionResponse = await retryFetch(GOOGLE_PAY_JWT_CONFIG.GOOGLE_PAY_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_id: GOOGLE_PAY_JWT_CONFIG.CLIENT_ID,
      location_id: GOOGLE_PAY_JWT_CONFIG.LOCATION_ID,
      validation_url: validationUrl,
      merchant_name: GOOGLE_PAY_JWT_CONFIG.MERCHANT_NAME,
    }),
  })

  const merchantSessionData = (await merchantSessionResponse.json()) as MerchantSessionResponse
  return { token: merchantSessionData.token }
}

export const useQueryGetGooglePayJwtToken = createReactQueryHook('getGooglePayJwtToken', getGooglePayJwtToken)
